module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/regular-62d0127fec3a727c978acb86d769079a.woff";